import { useEffect, useState } from 'react';
import axios from 'axios';
import { AUTH_API_URL } from '../config/api';

// Until the server answers (and if it can't be reached) the page behaves as it
// did before Google sign-in: password sign-in shown, no Google button. The
// server still enforces the real setting, so this fallback grants nothing.
const FALLBACK = { googleClientId: null, passwordLoginEnabled: true };

/**
 * Which sign-in methods the server allows:
 * GET /users/google-login/ -> { enabled, client_id, password_login_enabled }.
 * Both values live only in the Django env (GOOGLE_CLIENT_ID,
 * PASSWORD_LOGIN_ENABLED), so changing them needs no frontend rebuild.
 *
 * Returns { loaded, googleClientId, passwordLoginEnabled }.
 */
export function useLoginOptions() {
  const [options, setOptions] = useState({ loaded: false, ...FALLBACK });

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${AUTH_API_URL}google-login/`, { withCredentials: true })
      .then(({ data }) => {
        if (cancelled) return;
        setOptions({
          loaded: true,
          googleClientId: data?.enabled && data.client_id ? data.client_id : null,
          passwordLoginEnabled: data?.password_login_enabled !== false,
        });
      })
      .catch((error) => {
        console.warn('Sign-in options unavailable:', error.message);
        if (!cancelled) setOptions({ loaded: true, ...FALLBACK });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}

export default useLoginOptions;
